import { render, staticRenderFns } from "./ToolbarDaBusca.vue?vue&type=template&id=3b6d823e"
import script from "./ToolbarDaBusca.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolbarDaBusca.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports